import { Directive, ElementRef, Input, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[sortColumns]',
  standalone: true,
})
export class SortColumnsDirective {
  @Input() loading: boolean;
  @Input() pageName: string;
  @Input() applySortColumns: boolean;

  rows: NodeListOf<HTMLTableRowElement>;

  constructor(private el: ElementRef) {}

  ngAfterViewInit(): void {
    let timeOut = setTimeout(() => {
      this.sortAndAssignOrder();
      clearTimeout(timeOut);
    }, 1000);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.loading) {
      let timeOut = setTimeout(() => {
        this.sortAndAssignOrder();
        clearTimeout(timeOut);
      }, 100);
    }
  }

  sortAndAssignOrder() {
    if (!this.applySortColumns) return;
    const tableRow = this.el.nativeElement.querySelector('thead tr');
    if (!tableRow) return;

    const thElements: HTMLElement[] = Array.from(
      this.el.nativeElement.querySelectorAll('th')
    );

    if (!thElements) return;
    // Sort th elements based on the order attribute
    thElements.sort((a, b) => {
      const orderA = parseInt(a.getAttribute('order') || '0', 10);
      const orderB = parseInt(b.getAttribute('order') || '0', 10);
      return orderA - orderB;
    });

    // Clear all existing th elements
    tableRow.innerHTML = '';

    // Append sorted th elements and set related td elements
    thElements?.forEach((th) => {
      tableRow.appendChild(th);
    });

    this.sortTdElements();
  }

  sortTdElements() {
    this.getRowsList();

    this.rows?.forEach((tr) => {
      const tds = Array.from(tr.querySelectorAll('td')).sort((a, b) => {
        const orderA = parseInt(a.getAttribute('order') || '0', 10);
        const orderB = parseInt(b.getAttribute('order') || '0', 10);
        return orderA - orderB;
      });
      tds.forEach((td) => tr.appendChild(td));
    });
  }

  getRowsList() {
    this.rows = document.querySelectorAll(`${this.pageName} tbody tr`);
  }
}
